import {
    accessTimeOutlined,
    accessTimeOutlinedGrey,
    accessTimeOutlinedWhite,
    addOutlined,
    arrowBackIosNewOutlined,
    arrowBackIosNewOutlinedWhite,
    battery0BarOutlined,
    batteryCharging20Outlined,
    busAlertOutlinedGrey,
    busAlertOutlined3,
    busAlertOutlined4,    
    chargingStationOutlined,
    chargingStationOutlinedWhite,
    checkOutlined,
    clearOutlinedBlack,
    clearOutlinedGrey,
    clearOutlinedWhite,
    constructionOutlined,
    constructionOutlinedGrey,
    contentCopyOutlined,
    contentCopyOutlinedBlue,
    corporateFareOutlinedWhite,
    dateRangeOutlined,
    deleteForeverOutlined,
    deleteForeverOutlinedBlue,
    deleteForeverOutlinedBlack,
    directionsBusFilledOutlined,
    directionsBusFilledOutlinedBlue,
    directionsBusFilledOutlinedGrey,
    directionsBusFilledOutlinedWhite,
    doNotDisturbOutlined,
    editOutlined,
    editOutlinedBlue,
    emailOutlined,
    emailOutlinedBlue,
    emailOutlinedWhite,
    evStationOutlined,
    evStationOutlinedWhite,
    expandCircleDownOutlined,
    expandMoreOutlined,
    fileDownloadOutlined,
    fileDownloadOutlinedWhite,
    filter,
    headerCircle,
    infoOutlined,
    infoOutlinedBlue,
    infoOutlinedWhite,
    localParkingOutlined,
    localParkingOutlinedWhite,
    lockOutlined,
    logoutOutlined,
    loupeOutlined,
    loupeOutlinedBlue,
    loupeOutlinedWhite,
    mapOutlined,
    mapOutlinedWhite,
    noTransferOutlined,
    noTransferOutlinedWhite,
    permIdentityOutlined,
    placeOutlined,
    placeOutlinedWhite,
    playCircleOutlineOutlined,
    playCircleOutlineOutlinedWhite,
    powerSettingsNewOutlined,
    removeOutlined,
    searchOutlined,
    searchOutlinedGrey,
    settingsOutlined,
    settingsOutlinedGrey,
    shareOutlined,
    shareOutlinedWhite,
    starBorderOutlined,
    storefrontOutlined,
    storefrontOutlinedWhite,
    unfoldMoreOutlined,
    verifiedOutlined,
    verifiedOutlinedGrey,
    verifiedOutlinedBlue,
    viewBus,
    viewBusBlue,
    viewBusWhite,
    visibilityOffOutlined,
    visibilityOutlined,
    visibilityOutlinedBlack,
    visibilityOutlinedBlue,
    visibilityOutlinedWhite,
    warehouseOutlined,
    warehouseOutlinedWhite,
    warehouseOutlined1,
    warningAmberOutlined,
    warningAmberOutlinedRed,
    busAlertOutlinedWhite,

} from "../assets/img/icons";

import {
    DD12,
    DD20,
    DE00,
    DE01,
    DF20,
    DH10,
    DJ10,
    DJ20,
    EB00,
    EB10,
    EB30,
    EB40,
    EB80,
    EB90,
    EB91,
    EC10,
    EC11,
    EC30,
    EH00,
    EH10,
    EH20,
    EJ00,
    EJ20,
    EL10,
    EM00,
    EM01,
    EM10,
    EM20,
    EM100,
    EM300,
    EM400,
    EV00,
    EV10,
    EV11,
    EV20,
    EV21,
    FA00,
    FA01,
    FB10,
    FB20,
    FB21,
    FB30,
    FB80,
    FB91,
    FC21,
    FC30,
    FD21,
    FF00,
    FG00,
    FG01,
    FG60,
    FIB1,
    FIB7,
    FJ00,
    FJ01,
    FJ41,
    FK00,
    FK01,
    FL30,
    FL80,
    FP01,
    FP10,
    FP11,
    FQ00,
    FQ01,
    FS00,
    FS01,
    MB00,
    MB70,
    MC00,
    MH21,
    MH22,
    MJ30,
    MZ00,
} from '../assets/img/iconsAlertBus';

export const getIcons = title => {
  switch (title) {
    /*********************  ICONES PRINCIPAUX *********************/
    case ("accessTimeOutlined"):
      return accessTimeOutlined;
    case ("accessTimeOutlinedGrey"):
      return accessTimeOutlinedGrey;
    case ("accessTimeOutlinedWhite"):
      return accessTimeOutlinedWhite;
    case ("addOutlined"):
      return addOutlined;
    case ("arrowBackIosNewOutlined"):
      return arrowBackIosNewOutlined;
    case ("arrowBackIosNewOutlinedWhite"):
      return arrowBackIosNewOutlinedWhite;
    case ("battery0BarOutlined"):
      return battery0BarOutlined;
    case ("batteryCharging20Outlined"):
      return batteryCharging20Outlined;
    case ("busAlertOutlinedGrey"):
      return busAlertOutlinedGrey;
    case ("busAlertOutlined3"):
      return busAlertOutlined3;
    case ("busAlertOutlined4"):
      return busAlertOutlined4;    
    case ("busAlertOutlinedWhite"):
      return busAlertOutlinedWhite;
    case ("clearOutlinedBlack"):
      return clearOutlinedBlack;
    case ("clearOutlinedGrey"):
      return clearOutlinedGrey;
    case ("clearOutlinedWhite"):
      return clearOutlinedWhite;
    case ("chargingStationOutlined"):
      return chargingStationOutlined;
    case ("chargingStationOutlinedWhite"):
      return chargingStationOutlinedWhite;
    case ("checkOutlined"):
      return checkOutlined;
    case ("constructionOutlined"):
      return constructionOutlined;
    case ("constructionOutlinedGrey"):
      return constructionOutlinedGrey;
    case ("contentCopyOutlined"):
      return contentCopyOutlined;
    case ("contentCopyOutlinedBlue"):
      return contentCopyOutlinedBlue;
    case ("corporateFareOutlinedWhite"):
      return corporateFareOutlinedWhite;
    case ("dateRangeOutlined"):
      return dateRangeOutlined;
    case ('deleteForeverOutlined'):
      return deleteForeverOutlined;
    case ('deleteForeverOutlinedBlue'):
      return deleteForeverOutlinedBlue;
    case ('deleteForeverOutlinedBlack'):
      return deleteForeverOutlinedBlack;
    case ("directionsBusFilledOutlined"):
      return directionsBusFilledOutlined;
    case ("directionsBusFilledOutlinedBlue"):
      return directionsBusFilledOutlinedBlue;
    case ("directionsBusFilledOutlinedGrey"):
      return directionsBusFilledOutlinedGrey; 
    case ("directionsBusFilledOutlinedWhite"):
      return directionsBusFilledOutlinedWhite; 
    case ("doNotDisturbOutlined"):
      return doNotDisturbOutlined; 
    case ("editOutlined"):
      return editOutlined;
    case ("editOutlinedBlue"):
      return editOutlinedBlue; 
    case ("emailOutlined"):
      return emailOutlined;
    case ("emailOutlinedBlue"):
      return emailOutlinedBlue;
    case ("emailOutlinedWhite"):
      return emailOutlinedWhite; 
    case ("evStationOutlined"):
      return evStationOutlined; 
    case ("evStationOutlinedWhite"):
      return evStationOutlinedWhite; 
    case ("expandCircleDownOutlined"):
      return expandCircleDownOutlined; 
    case ("expandMoreOutlined"):
      return expandMoreOutlined; 
    case ("fileDownloadOutlined"):
      return fileDownloadOutlined; 
    case ("fileDownloadOutlinedWhite"):
      return fileDownloadOutlinedWhite; 
    case ("filter"):
      return filter; 
    case ('headerCircle'):
      return headerCircle;
    case ("infoOutlined"):
      return infoOutlined;
    case ("infoOutlinedBlue"):
      return infoOutlinedBlue;
    case ("infoOutlinedWhite"):
      return infoOutlinedWhite;
    case ("localParkingOutlined"):
      return localParkingOutlined;
    case ("localParkingOutlinedWhite"):
      return localParkingOutlinedWhite;
    case ("lockOutlined"):
      return lockOutlined;
    case ('logoutOutlined'):
      return logoutOutlined;  
    case ("loupeOutlined"):
      return loupeOutlined;
    case ("loupeOutlinedBlue"):
      return loupeOutlinedBlue;
    case ("loupeOutlinedWhite"):
      return loupeOutlinedWhite;
    case ("mapOutlined"):
      return mapOutlined;
    case ("mapOutlinedWhite"):
      return mapOutlinedWhite;
    case ("noTransferOutlined"):
      return noTransferOutlined;
    case ("noTransferOutlinedWhite"):
      return noTransferOutlinedWhite;
    case ("permIdentityOutlined"):
      return permIdentityOutlined;
    case ("placeOutlined"):
      return placeOutlined;
    case ("placeOutlinedWhite"):
      return placeOutlinedWhite;
    case ("playCircleOutlineOutlined"):
      return playCircleOutlineOutlined;
    case ("playCircleOutlineOutlinedWhite"):
      return playCircleOutlineOutlinedWhite;
    case ("powerSettingsNewOutlined"):
      return powerSettingsNewOutlined;
    case ("removeOutlined"):
      return removeOutlined;
    case ("searchOutlined"):
      return searchOutlined;
    case ("searchOutlinedGrey"):
      return searchOutlinedGrey;
    case ("shareOutlined"):
      return shareOutlined;
    case ("shareOutlinedWhite"):
      return shareOutlinedWhite;
    case ("starBorderOutlined"):
      return starBorderOutlined;
    case ("storefrontOutlined"):
      return storefrontOutlined;
    case ("storefrontOutlinedWhite"):
      return storefrontOutlinedWhite;
    case ("unfoldMoreOutlined"):
      return unfoldMoreOutlined;
    case ("verifiedOutlined"):
      return verifiedOutlined;
    case ("verifiedOutlinedGrey"):
      return verifiedOutlinedGrey;
    case ("verifiedOutlinedBlue"):
      return verifiedOutlinedBlue;
    case ("viewBus"):
      return viewBus;
    case ("viewBusBlue"):
      return viewBusBlue;
    case ("viewBusWhite"):
      return viewBusWhite;
    case ("visibilityOffOutlined"):
      return visibilityOffOutlined;
    case ("visibilityOutlined"):
      return visibilityOutlined;
    case ("visibilityOutlinedBlack"):
      return visibilityOutlinedBlack;
    case ("visibilityOutlinedBlue"):
      return visibilityOutlinedBlue;
    case ("visibilityOutlinedWhite"):
      return visibilityOutlinedWhite;
    case ("warehouseOutlined"):
      return warehouseOutlined;
    case ("warehouseOutlinedWhite"):
      return warehouseOutlinedWhite;
    case ("warehouseOutlined1"):
      return warehouseOutlined1;
    case ("warningAmberOutlined"):
      return warningAmberOutlined;
    case ("warningAmberOutlinedRed"):
      return warningAmberOutlinedRed;
    case ("settingsOutlined"):
      return settingsOutlined;
    /*********************  ICONES D'ALERTES *********************/
    case "DD12":
        return DD12;
    case "DD20":
        return DD20;
    case "DE00":
        return DE00;
    case "DE01":
        return DE01;
    case "DF20":
        return DF20;
    case "DH10":
        return DH10;
    case "DJ10":
        return DJ10;
    case "DJ20":
        return DJ20;
    case "EB00":
        return EB00;
    case "EB10":
        return EB10;
    case "EB30":
        return EB30;
    case "EB40":
        return EB40;
    case "EB80":
        return EB80;
    case "EB90":
        return EB90;
    case "EB91":
        return EB91;
    case "EC10":
        return EC10;
    case "EC11":
        return EC11;
    case "EC30":
        return EC30;
    case "EH00":
        return EH00;
    case "EH10":
        return EH10;
    case "EH20":
        return EH20;
    case "EJ00":
        return EJ00;
    case "EJ20":
        return EJ20;
    case "EL10":
    case "EM200":
        return EL10;
    case "EM00":
        return EM00;
    case "EM01":
        return EM01;
    case "EM10":
        return EM10;
    case "EM20":
        return EM20;
    case "EM100":
        return EM100;
    case "EM300":
        return EM300;
    case "EM400":
        return EM400;
    case "EV00":
        return EV00;
    case "EV10":
        return EV10;
    case "EV11":
        return EV11;
    case "EV20":
        return EV20;
    case "EV21":
        return EV21;
    case "FA00":
        return FA00;
    case "FA01":
        return FA01;
    case "FB10":
        return FB10;
    case "FB20":
        return FB20;
    case "FB21":
        return FB21;
    case "FB30":
        return FB30;
    case "FB80":
        return FB80;
    case "FB91":
        return FB91;
    case "FC21":
        return FC21;
    case "FC30":
        return FC30;
    case "FD21":
        return FD21;
    case "FF00":
        return FF00;
    case "FG00":
        return FG00;
    case "FG01":
        return FG01;
    case "FG60":
        return FG60;
    case "FIB1":
        return FIB1;
    case "FIB7":
        return FIB7;
    case "FJ00":
        return FJ00;
    case "FJ01":
        return FJ01;
    case "FJ41":
        return FJ41;
    case "FK00":
        return FK00;
    case "FK01":
        return FK01;
    case "FL30":
        return FL30;
    case "FL80":
        return FL80;
    case "FP01":
        return FP01;
    case "FP10":
        return FP10;
    case "FP11":
        return FP11;
    case "FQ01":
        return FQ01;
    case "FQ00":
        return FQ00;
    case "FS00":
        return FS00;
    case "FS01":
        return FS01;
    case "MB00":
        return MB00;
    case "MB70":
        return MB70;
    case "MC00":
        return MC00;
    case "MH21":
        return MH21;
    case "MH22":
        return MH22;
    case "MJ30":
        return MJ30;
    case "MZ00":
        return MZ00;    
    default: 
      return settingsOutlinedGrey;
  }
}